<template>
  <div id="formulario-de-solicitacao">
    <div class="container container_com-fundo container_com-margem">
      <alerta :tipo="'erro'" :texto="mensagemDeErro" />
      <form @submit.prevent="salvarSolicitacao">
        <h2 class="titulo titulo_grande">Preencha todos os campos obrigatórios abaixo para solicitar o subsídio.</h2>
        <h3 class="subtitle is-5">
          <i class="fal fa-sack-dollar"></i> Dados do financiamento
        </h3>
        <div class="">
          <div class="">
            <div class="grade__linha">
              <div class="grade__coluna grade__coluna_4">
                <label class="formulario__label" for="valor-da-compra-e-venda">
                  Valor de comercialização
                  <span class="tooltips">
                    <i class="fa fa-info-circle" id="tooltipValorDoFinanciamento" aria-hidden="true"></i>
                    <span class="conteudo tooltip-top">O valor de comercialização, é o total da soma de todos os campos em
                      destaque. </span>
                  </span>
                </label>
                <input id="valor-da-compra-e-venda" class="formulario__input" type="text" placeholder="130.000,00"
                  v-model="financiamento.ValorDaCompraEVenda" v-mask="'money'" required />
              </div>
              <div class="grade__coluna grade__coluna_4">
                <label class="formulario__label" for="valor-de-avaliacao">Valor de avaliação</label>
                <input id="valor-de-avaliacao" class="formulario__input destacar-campos" type="text"
                  placeholder="130.000,00" v-model="financiamento.ValorDeAvaliacao" v-mask="'money'" required />
              </div>
              <div class="grade__coluna grade__coluna_4">
                <label class="formulario__label" for="valor-do-financiamento-aprovado">Valor do financiamento
                  concedido</label>
                <input id="valor-do-financiamento-aprovado" class="formulario__input destacar-campos" type="text"
                  placeholder="90.000,00" v-model="financiamento.ValorDoFinanciamentoAprovado" v-mask="'money'" required />
              </div>
            </div>
          </div>
          <div class="grade__linha">
            <div class="grade__coluna grade__coluna_4">
              <label class="formulario__label" for="subsidio-governo-federal">Subsídio Governo Federal</label>
              <input id="subsidio-governo-federal" class="formulario__input destacar-campos" type="text"
                placeholder="14.000,00" v-model="financiamento.SubsidioDoGovernoFederal" v-mask="'money'" />
            </div>
            <div class="grade__coluna grade__coluna_4">
              <label class="formulario__label" for="codigo-de-avaliacao">Código de avaliação</label>
              <input id="codigo-de-avaliacao" class="formulario__input" type="number" placeholder="Somente números"
                v-model="financiamento.CodigoDeAvaliacao" number required/>
            </div>
            <div class="grade__coluna grade__coluna_3">
              <label class="formulario__label" for="data-de-avaliacao">Data de avaliação</label>
              <input id="data-de-avaliacao" class="formulario__input" type="date" v-model="financiamento.DataDeAvaliacao" required/>
            </div>
          </div>
          <div class="grade__linha">
              <p>
                <strong> Recursos próprios </strong>
              </p>
          </div>
          <div class="grade__linha">
            <div class="grade__coluna grade__coluna_4">
                <label class="formulario__label" for="desconto-da-construtora">Desconto da construtora na entrada</label>
                <input id="desconto-da-construtora" class="formulario__input destacar-campos" type="text" placeholder="10.000,00"
                  v-model="financiamento.DescontoConstrutora" v-mask="'money'" />
            </div>
            <div class="grade__coluna grade__coluna_4">
              <label class="formulario__label" for="subsidio-solicitado-agehab">Subsídio solicitado AGEHAB</label>
              <input id="subsidio-solicitado-agehab" class="formulario__input destacar-campos" type="text"
                placeholder=" 6.000,00" v-model="financiamento.SubsidioDaAgehab" v-mask="'money'" disabled />
            </div>
            <div class="grade__coluna grade__coluna_4">
              <label class="formulario__label" for="participacao-necessaria">Participação do proponente</label>
              <input id="participacao-necessaria" class="formulario__input destacar-campos" type="text"
                placeholder="10.000,00" v-model="financiamento.ParticipacaoDoSolicitante" v-mask="'money'" />
            </div>
          </div>
        </div>
        <div class="grade__linha">
          <router-link to="/consulta-por-cpf" class="botao botao_cinza botao_medio"
            :class="{ 'is-disabled': loading }">Cancelar</router-link>
          <button type="submit" class="botao botao_medio botao_cor-terciaria u-margem-esquerda-media"
            :class="{ 'is-loading': loading }">Salvar</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import AwesomeMask from 'awesome-mask';
import Alerta from '../shared/Alerta';

export default {
  name: 'formulario-de-solicitacao',
  directives: { mask: AwesomeMask },
  components: { Alerta },
  data() {
    return {
      loading: false,
      mensagemDeErro: null,
      financiamento: {}
    };
  },
  mounted() {
    const tooltip = document.getElementById('tooltipValorDoFinanciamento');
    tooltip.onmouseover = () => {
      const camposDeValor = document.querySelectorAll('.destacar-campos');
      for (let i = 0; i < camposDeValor.length; i += 1) {
        camposDeValor[i].className += ' habilitado';
      }
    };

    tooltip.onmouseleave = () => {
      const camposDeValor = document.querySelectorAll('.destacar-campos');
      for (let i = 0; i < camposDeValor.length; i += 1) {
        camposDeValor[i].classList.remove('habilitado');
      }
    };
  },
  beforeCreate() {
    this.loading = true;
    const idDaSolicitacao = this.$route.query.idDaSolicitacao;

    this.$api.get(`/solicitacao/${idDaSolicitacao}`).then((response) => {
      this.financiamento = response.data.Financiamento;
      this.financiamento.SolicitacaoId = idDaSolicitacao;
      this.financiamento.ValorDeAvaliacao = this.$moeda.formatar(this.financiamento.ValorDeAvaliacao);
      this.financiamento.ValorDaCompraEVenda = this.$moeda.formatar(this.financiamento.ValorDaCompraEVenda);
      this.financiamento.ValorDoFinanciamentoAprovado = this.$moeda.formatar(this.financiamento.ValorDoFinanciamentoAprovado);
      this.financiamento.ParticipacaoDoSolicitante = this.$moeda.formatar(this.financiamento.ParticipacaoDoSolicitante);
      this.financiamento.SubsidioDoGovernoFederal = this.$moeda.formatar(this.financiamento.SubsidioDoGovernoFederal);
      this.financiamento.SubsidioDaAgehab = this.$moeda.formatar(this.financiamento.SubsidioDaAgehab);
      this.financiamento.DescontoConstrutora = this.$moeda.formatar(this.financiamento.DescontoConstrutora);
      this.financiamento.DataDeAvaliacao = this.formatarComAnoMesDia(this.financiamento.DataDeAvaliacao);
      this.loading = false;
    }).catch((error) => {
      console.error(error);
    });
  },
  methods: {
    formatarComAnoMesDia(dataSemFormatacao) {
      const data = new Date(dataSemFormatacao);
    	return data && new Date(data.getTime()-(data.getTimezoneOffset()*60*1000)).toISOString().split('T')[0]
    },
    salvarSolicitacao() {
      this.loading = true;

      const financiamento = Object.assign({}, this.financiamento);
      financiamento.ValorDeAvaliacao = this.$moeda.removerFormatacao(this.financiamento.ValorDeAvaliacao);
      financiamento.ValorDaCompraEVenda = this.$moeda.removerFormatacao(this.financiamento.ValorDaCompraEVenda);
      financiamento.ValorDoFinanciamentoAprovado = this.$moeda.removerFormatacao(this.financiamento.ValorDoFinanciamentoAprovado);
      financiamento.ParticipacaoDoSolicitante = this.$moeda.removerFormatacao(this.financiamento.ParticipacaoDoSolicitante);
      financiamento.SubsidioDoGovernoFederal = this.$moeda.removerFormatacao(this.financiamento.SubsidioDoGovernoFederal);
      financiamento.SubsidioDaAgehab = this.$moeda.removerFormatacao(this.financiamento.SubsidioDaAgehab);
      financiamento.DescontoConstrutora = this.$moeda.removerFormatacao(this.financiamento.DescontoConstrutora);

      this.$api.post('/Solicitacao/AlterarValores', financiamento).then(() => {
        const idDaSolicitacao = this.$route.query.idDaSolicitacao;
        this.$router.push({ name: 'VisualizarSolicitacao', query: { idDaSolicitacao } });
      }).catch((error) => {
        const mensagensDeErro = error.response.data.Message;

        if (mensagensDeErro) {
          this.mensagemDeErro = mensagensDeErro.split(',').join('<br />');
        } else {
          this.mensagemDeErro = 'Desculpe, ocorreu um erro interno. Tente novamente ou contate o suporte';
        }

        this.loading = false;
        window.scrollTo(0, 0);
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// EditarValoresDaSolicitacao.vue?1e682928